export default class Command {
    constructor(item) {
        //Id
        this.id = item != null ? item.id : ''

        //Invoice info
        this.administrationId = item != null ? item.administrationId : ''
        this.invoiceNumber = item != null ? item.invoiceNumber : ''
        this.contactPersonIds = item != null ? item.contactPersons != undefined ? item.contactPersons.map(x=>x.id) : [] : []

        //Delivery information
        this.reference = item != null ? item.reference : ''
        this.assignedUserIds = item != null ? item.assignedUsers != undefined ? item.assignedUsers.map(x=> x.id) : [] : []
        this.printingCompany = item != null ? item.printingCompany : ''
        this.diffuser= item != null ? item.diffuser : ''
        this.publisher= item != null ? item.publisher : ''
        this.status = item != null ? item.status : 0

        //Dates
        this.firstTestDate= item != null ? item.firstTestDate : null   
        this.printingCompanyDate= item != null ? item.printingCompanyDate : null
        this.diffuserDate= item != null ? item.diffuserDate : null
        this.deliveryDate= item != null ? item.deliveryDate : null

        //Meta info
        this.numberOfOffersSent = item != null ? item.numberOfOffersSent : 0
    }
}